module.exports = __webpack_public_path__ + "static/media/record-top.fd639b94.JPG";